import { supabase } from '@/lib/supabase/config';
export async function getAvailableProjectSubscriptions(organizationId: number) {
  const { data, error } = await supabase.rpc(
    'get_available_project_subscriptions',
    {
      p_organization_id: organizationId,
    },
  );

  if (error) {
    throw new Error(error.message || 'Failed to check project subscription');
  }

  return data;
}
